import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Mail, ArrowLeft, CheckCircle, AlertCircle } from 'lucide-react';
import HelpButton from '../common/HelpButton';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  
  const { forgotPassword } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await forgotPassword(email);
      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="cam-auth-page">
        <div className="cam-auth-container cam-forgot-container">
          <div className="card-cam cam-forgot-card">
            <div className="cam-help-button-wrapper">
              <HelpButton />
            </div>

            <div className="cam-form-header text-center mb-5">
              <div className="cam-success-icon">
                <CheckCircle size={32} color="white" />
              </div>
              <h2 className="cam-form-title">Check Your Email</h2>
              <p className="cam-form-subtitle">
                We've sent a password reset link to <strong>{email}</strong>
              </p>
              <p className="cam-form-subtitle mt-2">
                Please check your email and follow the instructions to reset your password.
              </p>
            </div>

            <div className="d-flex flex-column gap-3">
              <Link to="/login" className="btn-cam w-100 text-center">
                <ArrowLeft size={18} />
                Back to Login
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="cam-auth-page">
      <div className="cam-auth-container cam-forgot-container">
        <div className="card-cam cam-forgot-card">
          <div className="cam-help-button-wrapper">
            <HelpButton />
          </div>

          <div className="cam-form-header text-center mb-5">
            <h2 className="cam-form-title">Forgot Password?</h2>
            <p className="cam-form-subtitle">
              Enter your email address and we'll send you a reset link
            </p>
          </div>

          {error && (
            <div className="cam-error-alert">
              <AlertCircle size={16} />
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="cam-form-group">
              <label className="cam-form-label">Email Address</label>
              <div className="cam-input-wrapper">
                <Mail size={18} className="cam-input-icon" />
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  className="input-cam cam-input-with-icon"
                  required
                />
              </div>
            </div>

            <button
              type="submit"
              className="btn-cam w-100 mb-4"
              disabled={loading}
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </form>

          <div className="d-flex align-items-center justify-content-center gap-2">
            <Link to="/login" className="cam-forgot-link d-flex align-items-center gap-2">
              <ArrowLeft size={16} />
              Back to Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
